import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import cmcUsageCache from './CmcUsageCache';
import cmcUsageFetcher from './CmcUsageFetcher';
import CmcUsageCalculator from './CmcUsageCalculator';
import { events } from '@/services/wss/SystemEvents';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';

class CmcUsageEngine extends WssEventHandlerBase {
    _name = 'CmcUsageEngine';

    bootup() {
        try {
            super.bootup();
            this.clear();

            this._unsub = this._wsNotifier.subscribe(events.OnCmcUsageUpdated, this.onUsageReceived);
        } catch (error) {
            this.logError('bootup', error.message);
        }
    }

    /**
     * cleanup removes event handlers
     */
    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * SignalR handler — called from PageContentSRHandlers on new pushed usage items.
     *
     * @param {object} data - CmcUsageItemDto containing usages for month and day
     */
    onUsageReceived = (data) => {
        try {
            // const items = data.items;
            cmcUsageCache.addOrUpdate(data);
            this._notify();
        } catch (error) {
            this.logError('onUsageReceived', error.message);
        }
    };

    /**
     * @returns {object|null} render-state derived from the cached usage items
     */
    getState = () => CmcUsageCalculator.buildState(cmcUsageCache.getAll());

    /**
     * Fetches the current usage items via REST. Called once from PageContent
     * alongside the other engines' fetch/fetchAll calls.
     * @returns {Promise<void>}
     */
    fetch = async () => {
        try {
            const rawItems = await cmcUsageFetcher.fetch();
            if (!rawItems.length) return;

            cmcUsageCache.addOrUpdate(rawItems);
            this._notify();
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    _notify = () => {
        ComponentNotifier.notify(this._name, 'dataChanged', { state: this.getState() });
    };
}

const cmcUsageEngine = new CmcUsageEngine();
export default cmcUsageEngine;
